export interface CustodyAccountPreEligibilityResponse {
	eligible: boolean;
}

export interface CustodyAccountVerifiedEligibilityResponse {
	eligibility_status: CustodyAccountVerifiedEligibility;
}

export enum CustodyAccountVerifiedEligibility {
	UNKNOWN = "UNKNOWN",
	MISSING_REQUIRED_DATA = "MISSING_REQUIRED_DATA",
	NOT_ELIGIBLE = "NOT_ELIGIBLE",
	ELIGIBLE = "ELIGIBLE"
}
